<template>
  <svg class="icon icon--headphones" wclassth="72px" height="59px" viewBox="0 0 72 59" version="1.1"
       xmlns="http://www.w3.org/2000/svg">
    <g class="Desktop" stroke="none" stroke-wclassth="1" fill="none" fill-rule="evenodd">
      <g class="main" transform="translate(-686.000000, -461.000000)" fill-rule="nonzero" fill="#ffffff">
        <g class="Headphones" transform="translate(686.000000, 461.000000)">
          <path
            d="M5.9761606,37.92 C5.81806775,36.64 5.73902133,35.36 5.73902133,34 C5.73902133,16.32 19.0188206,1.92 35.4604768,1.92 C51.902133,1.92 65.1819322,16.4 65.1819322,34.08 C65.1819322,35.36 65.1028858,36.72 64.944793,38 L66.7628607,38 C66.9209536,36.72 67,35.44 67,34.08 C67,15.28 52.8506901,0 35.5395232,0 C18.2283563,0 4,15.28 4,34.08 C4,35.36 4.07904642,36.72 4.23713927,38 L5.9761606,38 L5.9761606,37.92 Z"
            class="Shape"></path>
          <path
            d="M11,59 L9.87591241,58.8367347 C4.25547445,58.1836735 0,53.0408163 0,47 C0,40.9591837 4.25547445,35.8163265 9.87591241,35.1632653 L11,35 L11,59 Z M9.0729927,37.3673469 C4.97810219,38.4285714 2.00729927,42.3469388 2.00729927,47.0816327 C2.00729927,51.7346939 4.97810219,55.7346939 9.0729927,56.7959184 L9.0729927,37.3673469 Z"
            class="Shape"></path>
          <path
            d="M61,58 L61,35 L62.1240876,35.1569966 C67.7445255,35.7849829 72,40.7303754 72,46.5392491 C72,52.3481229 67.7445255,57.2935154 62.1240876,57.9215017 L61,58 Z M62.9270073,37.1979522 L62.9270073,55.8020478 C67.0218978,54.78157 69.9927007,51.0136519 69.9927007,46.4607509 C69.9927007,41.9863481 67.0218978,38.21843 62.9270073,37.1979522 Z"
            class="Shape"></path>
          <path
            d="M59.5,59 C57.5217391,59 56,57.3386076 56,55.3607595 L56,37.6392405 C56,35.5822785 57.5978261,34 59.5,34 C61.4782609,34 63,35.6613924 63,37.6392405 L63,55.3607595 C63,57.3386076 61.4021739,59 59.5,59 Z M59.5,35.8987342 C58.5869565,35.8987342 57.826087,36.6898734 57.826087,37.6392405 L57.826087,55.3607595 C57.826087,56.3101266 58.5869565,57.1012658 59.5,57.1012658 C60.4130435,57.1012658 61.173913,56.3101266 61.173913,55.3607595 L61.173913,37.6392405 C61.173913,36.6898734 60.4130435,35.8987342 59.5,35.8987342 Z"
            class="Shape"></path>
          <path
            d="M12.5,59 C10.5217391,59 9,57.3386076 9,55.3607595 L9,37.6392405 C9,35.5822785 10.5978261,34 12.5,34 C14.4021739,34 16,35.6613924 16,37.6392405 L16,55.3607595 C16,57.3386076 14.4782609,59 12.5,59 Z M12.5,35.8987342 C11.5869565,35.8987342 10.826087,36.6898734 10.826087,37.6392405 L10.826087,55.3607595 C10.826087,56.3101266 11.5869565,57.1012658 12.5,57.1012658 C13.4130435,57.1012658 14.173913,56.3101266 14.173913,55.3607595 L14.173913,37.6392405 C14.173913,36.6898734 13.4130435,35.8987342 12.5,35.8987342 Z"
            class="Shape"></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return {}
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/Headphones.vue